import { combineReducers } from "@reduxjs/toolkit";
import clientAuth from "../components/auth-client/slice/clientAuth";
import clientChat from "../components/client-chat/slice/clientChatSlice";
import clientChatList from "../components/client-chatList/slice/clientChatListSlice";
import clientListing from "../components/client-listing/slice/clientListingSlice";
import clientNavigation from "../components/client-navbar/slice/clientNavigationSlice";
import clientServices from "../components/client-services/slice/clientServicesSlice";
import clientServiceDetails from "../components/client-service-details/slice/clientServiceDetailsSlice";
import clientTickets from "../components/client-tickets/slice/clientTicketSlice";
import clientInfo from "../components/client-panel/slice/clientPanelInfoSlice";
import clientDocument from "../components/client-panel/slice/clientPanelDocumentSlice";
import clientChildIssue from "../components/client-panel/slice/clientPanelChildIssueSlice";
import clientAppointment from "../components/client-panel/slice/clientPanelAppointmentSlice";
import clientSelfAssessment from "../components/client-panel/slice/clientPanelSelfAssessmentSlice";
import clientListPayment from "../components/client-panel/slice/clientPanelListPaymentSlice";
import clientSuggestedServices from "../components/client-panel/slice/clientPanelSuggestedServicesSlice";
import clientClaim from "../components/client-panel/slice/clientPanelClaimSlice";
import clientDashboard from "../components/client-panel/slice/clientPanelDashboardSlice";
// import chatNotifications from "../components/client-header/slice/chatNotificationsSlice"
import fundraising from "../components/fundraising/slice/fundraisingSlice";

const clientRootReducer = {
  clientAuth,
  clientChat,
  clientChatList,
  clientListing,
  clientNavigation,
  clientServices,
  clientServiceDetails,
  clientTickets,
  clientInfo,
  clientDocument,
  clientChildIssue,
  clientAppointment,
  clientSelfAssessment,
  clientListPayment,
  clientClaim,
  clientSuggestedServices,
  clientDashboard,
  fundraising
  // chatNotifications
};

export default clientRootReducer;
